<script setup lang="ts">
const RouterLink = resolveComponent("router-link");
defineProps<{
  active?: boolean;
  link?: string | undefined | boolean | null | 0;
  itemClasses?: string;
}>();
</script>

<template>
  <li :class="{ active: active }">
    <slot name="itemContent">
      <component
        :is="!link ? 'button' : RouterLink"
        :class="itemClasses"
        :to="link"
        type="button"
      >
        <span v-show="$slots.before" class="before">
          <slot name="before"></slot>
        </span>

        <span class="content">
          <slot />
        </span>
        <span v-show="$slots.after" class="after">
          <slot name="after"></slot>
        </span>
      </component>
    </slot>
  </li>
</template>
